// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2GpU6","showModal":"Modal_showModal__hnDbK","outer":"Modal_outer__gfAO4","close":"Modal_close__2S9d9"};